function drawRadar(options = {}) {
  const canvasDom = document.querySelector(options.el)
  if (!canvasDom) {
    return console.warn('error query selector')
  }
  canvasDom.width = options.width || 150
  canvasDom.height = options.width || 150
  const ctx = canvasDom.getContext('2d')
  const rData = options.data || []
  const side = rData.length
  const radius = options.radius || 100
  const angle = (Math.PI * 2) / side // (Math.PI*2/360)*(360/side)
  const center = options.center
  const total = options.total || 10
  // const totalPointList = []
  const animationTimer = options.timer || 500
  const fillColor = options.fillColor
  let start
  function draw(timestamp) {
    if (start === undefined) start = timestamp
    const elapsed = timestamp - start
    ctx.save()
    ctx.beginPath()
    ctx.fillStyle = fillColor
    rData.forEach((item, index) => {
      const drawRate = Math.min(elapsed / animationTimer, 1)
      const dataRadius = (item.value * drawRate * radius) / total
      const dataX = center + dataRadius * Math.sin(angle * index)
      const dataY = center + dataRadius * Math.cos(angle * index)
      ctx.lineTo(dataX, dataY)
    })
    ctx.strokeStyle = options.contentBorderColor
    ctx.lineWidth = 4
    ctx.closePath()
    ctx.stroke()
    ctx.fill()
    ctx.restore()
    if (elapsed < animationTimer) {
      // 在两秒后停止动画
      window.requestAnimationFrame(draw)
    }
  }
  window.requestAnimationFrame(draw)
}

export default drawRadar
